export const getChangeCheckFieldEndpoints = (field_id) => {
  return {
    batch_processing: `tenant-check/batchcolumn/${field_id}`,
  };
};

export const getChangePackageFieldEndpoints = (field_id) => {
  return {
    batch_processing: `screening-package/batchcolumn/${field_id}`,
  };
};
